<template>
  <body class="class-1" id="dinein">
    <!-- header -->
    <PosAppHeader />
     <div class="back-btn-container ml-4 mt-2">
        <button class="btn btn-secondary" @click="goBack">
          <i class="fas fa-arrow-left"></i> Back
        </button>
      </div>
    <!-- main box -->
    <div class="main_box">
      <div class="left_panel dineintables ml-4">
        <div class="d-flex flex-column w-100">
          <!-- Split Invoice Section -->
          <div class="split-invoice-container p-3">
            <h4>Split Invoice</h4>
            
            <div class="split-container">
              <!-- Left Column - Controls -->
              <div class="split-controls">
                <div class="split-options mb-3">
                  <label class="mr-3">
                    <input type="radio" v-model="splitType" value="equal"> Equal Split
                  </label>
                  <label>
                    <input type="radio" v-model="splitType" value="unequal"> Unequal Split
                  </label>
                </div>
                
                <div class="form-group mb-3">
                  <label>Number of Splits:</label>
                  <div class="input-group" style="width: fit-content;">
                    <input 
                      type="number" 
                      v-model="numSplits" 
                      min="2" 
                      class="form-control" 
                      @click="openNumericKeypad('numSplits')"
                      readonly
                    >
                    <div class="input-group-append">
                      <button 
                        class="btn btn-outline-secondary" 
                        type="button" 
                        @click="openNumericKeypad('numSplits')"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" 
                             class="bi bi-keyboard" viewBox="0 0 16 16">
                          <path d="M14 5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12zM2 6v5h12V6H2z"/>
                          <path d="M13 7.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-3 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-3 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-3 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5z"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                
                <button @click="generateSplit" class="btn btn-primary mb-3">Generate Split</button>
                
              
              </div>
              
              <!-- Right Column - Preview -->
              <div class="split-preview-container">
                <!-- Equal Split Preview -->
                <div v-if="splitPreview.equal" class="split-preview">
                  <div v-for="(split, index) in splitPreview.splits" :key="index" class="split-group mb-4">
                    <h5>Split {{ index + 1 }}</h5>
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th>Quantity</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in split.items" :key="item.id">
                          <td>{{ item.name }}</td>
                          <td>{{ item.quantity }}</td>
                          <td>{{ item.price }}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="2"><strong>Subtotal:</strong></td>
                          <td>{{ split.subtotal }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                
                <!-- Unequal Split Preview -->
                <div v-if="splitPreview.unequal" class="split-preview">
                  <div v-for="(split, index) in splitPreview.splits" :key="index" class="split-group mb-4">
                    <h5>Split {{ index + 1 }}</h5>
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th>Quantity</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in split.items" :key="item.id">
                          <td>
                            {{ item.name }}
                            <span v-if="remainingQuantities[item.id] === 0" class="badge badge-success ml-2">
                              Fully allocated
                            </span>
                          </td>
                          <td>
                            <input 
                              type="number" 
                              v-model="item.quantity" 
                              min="0" 
                              :max="getMaxQuantity(item)"
                              class="form-control form-control-sm"
                              @change="updateUnequalSplit"
                              @click="openNumericKeypad('quantity', item, index)"
                              :disabled="remainingQuantities[item.id] === 0 && item.quantity === 0"
                              readonly
                            >
                            <small class="text-muted">
                              Remaining: {{ remainingQuantities[item.id] }}
                            </small>
                          </td>
                          <td>{{ (item.price * item.quantity).toFixed(2) }}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="2"><strong>Subtotal:</strong></td>
                          <td>{{ split.subtotal }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <button 
            style="width: fit-content;"
                  v-if="splitPreview.show" 
                  @click="confirmSplit" 
                  class="btn btn-success mt-2"
                  :disabled="!canConfirmSplit"
                >
                  Confirm Split
                </button>
        </div>
      </div>
    </div>
    <NumericKeypad ref="numericKeypad" @input="handleKeypadInput" @close="closeKeypad" />
  </body>
</template>

<script>
import NumericKeypad from './NumericKeypad.vue';
export default {
  components: {
    NumericKeypad
  },
  data() {
    return {
      orders: [],
      currentInput: null,
      keypadValue: '',
      currentItem: null,
      currentSplitIndex: null,
      menuVisible: false,
      totalTables: 0,
      availableTables: 0,
      busyTables: 0,
      mainOrderId: 0,
      mainTableId: 0,
      reservedTables: 0,
      splitType: 'equal',
      numSplits: 2,
      splitPreview: {
        equal: false,
        unequal: false,
        splits: [],
        show: false
      },
      orderItems: []
    }
  },
  computed: {
    remainingQuantities() {
      const remaining = {};
      this.orderItems.forEach(item => {
        remaining[item.id] = item.quantity - this.splitPreview.splits.reduce(
          (sum, split) => sum + split.items.find(i => i.id === item.id).quantity,
          0
        );
      });
      return remaining;
    },
    canConfirmSplit() {
      if (this.splitType === 'equal') return true;
      
      const allValid = this.splitPreview.splits.every(split => {
        return split.items.every(item => {
          return item.quantity >= 0 && 
                item.quantity <= item.maxQuantity;
        });
      });
      
      const fullyAllocated = Object.values(this.remainingQuantities).every(qty => qty === 0);
      const noNegative = Object.values(this.remainingQuantities).every(qty => qty >= 0);
      
      return allValid && fullyAllocated && noNegative;
    }
  },
  methods: {
     goBack() {
      this.$router.go(-1);
     
    },
    openNumericKeypad(fieldName, item = null, splitIndex = null) {
      this.currentInput = fieldName;
      
      if (fieldName === 'numSplits') {
        this.keypadValue = this.numSplits.toString();
        this.currentItem = null;
        this.currentSplitIndex = null;
      } else if (fieldName === 'quantity') {
        this.keypadValue = item.quantity.toString();
        this.currentItem = item;
        this.currentSplitIndex = splitIndex;
      }
      
      this.$refs.numericKeypad.inputValue = this.keypadValue;
      this.$refs.numericKeypad.show();
    },

    handleKeypadInput(value) {
      this.keypadValue = value;
      
      if (this.currentInput === 'numSplits') {
        this.numSplits = parseInt(value) || 0;
      } else if (this.currentInput === 'quantity' && this.currentItem && this.currentSplitIndex !== null) {
        // Update the quantity in the correct split
        const quantity = parseInt(value) || 0;
        this.splitPreview.splits[this.currentSplitIndex].items.find(
          i => i.id === this.currentItem.id
        ).quantity = quantity;
        
        // Trigger the update
        this.updateUnequalSplit();
      }
    },
    
    closeKeypad() {
      this.$refs.numericKeypad.hide();
    },
    
    getMaxQuantity(item) {
      const allocatedToOthers = this.splitPreview.splits.reduce((sum, split) => {
        const splitItem = split.items.find(i => i.id === item.id);
        return sum + splitItem.quantity;
      }, 0) - item.quantity; 
      
      return item.maxQuantity - allocatedToOthers;
    },
    
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    
    gotohome() {
      // Navigation logic
    },
    
    navigateToPos(order) {
      if (!this.$hasPermission('edit orders')) {
        this.$toast.error('Not Permitted');
        return;
      }
      this.$router.push({ name: "PosComponent", params: { orderId: order.id, tableId: order.tableId } });
    },
    
    calculateTableStats() {
      this.totalTables = this.orders.length;
      this.availableTables = this.orders.filter(order => order.tablesold === 0).length;
      this.busyTables = this.orders.filter(order => order.tablesold === 1).length;
      this.reservedTables = 0; 
    },
    
    async fetchOrderDetails() {
      const token = localStorage.getItem('authToken');
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };

      try {
        if (this.mainOrderId) {
          const orderResponse = await fetch(
            `${this.$BASE_API_URL}/api/orders/${this.mainOrderId}`,
            {
              method: 'GET',
              headers: headers,
            }
          );

          if (orderResponse.ok) {
            const orderData = await orderResponse.json();
            const order = orderData.data;
            
            this.orderItems = order.products.map(product => ({
              id: product.id,
              name: product.name || `Product ${product.id}`,
              price: parseFloat(product.pivot.price),
              quantity: product.pivot.count,
              maxQuantity: product.pivot.count,
              customizations: [], 
              note: product.pivot.note || ''
            }));
          } else {
            throw new Error('Failed to fetch order details');
          }
        }
      } catch (error) {
        console.error('API Error:', error);
        this.$toast.error('An error occurred while fetching order details');
      }
    },
    
    generateSplit() {
  if (this.numSplits < 2) {
    this.$toast.error('Number of splits must be at least 2');
    return;
  }

  this.splitPreview = {
    equal: this.splitType === 'equal',
    unequal: this.splitType === 'unequal',
    splits: [],
    show: true
  };

  if (this.splitType === 'equal') {
    // Create equal splits with divided quantities
    for (let i = 0; i < this.numSplits; i++) {
      this.splitPreview.splits.push({
        items: this.orderItems.map(item => ({
          ...item,
          quantity: item.quantity / this.numSplits, // Divide quantity by number of splits
          price: item.price // Keep original price
        })),
        subtotal: this.calculateSubtotal(
          this.orderItems.map(item => ({
            ...item,
            quantity: item.quantity / this.numSplits
          }))
        )
      });
    }
  } else {
    // Create unequal splits - initialize with all quantities at 0
    for (let i = 0; i < this.numSplits; i++) {
      this.splitPreview.splits.push({
        items: this.orderItems.map(item => ({
          ...item,
          quantity: 0
        })),
        subtotal: 0
      });
    }
  }
},
    
  updateUnequalSplit() {
  // First calculate remaining quantities before making changes
  const remainingBeforeUpdate = {};
  this.orderItems.forEach(item => {  // Fixed the typo here
    remainingBeforeUpdate[item.id] = item.quantity;
    this.splitPreview.splits.forEach(split => {
      const splitItem = split.items.find(i => i.id === item.id);
      remainingBeforeUpdate[item.id] -= splitItem.quantity;
    });
  });

  // Now validate each input
  this.splitPreview.splits.forEach(split => {
    split.items.forEach(item => {
      // Calculate how much is already allocated to other splits for this item
      const allocatedToOthers = this.splitPreview.splits
        .filter(s => s !== split)
        .reduce((sum, s) => {
          const otherItem = s.items.find(i => i.id === item.id);
          return sum + otherItem.quantity;
        }, 0);
      
      // Calculate maximum allowed for this split
      const maxAllowed = item.maxQuantity - allocatedToOthers;
      
      // Enforce the limit
      if (item.quantity > maxAllowed) {
        item.quantity = maxAllowed;
      }
      if (item.quantity < 0) {
        item.quantity = 0;
      }
    });
    
    // Update subtotal after validation
    split.subtotal = this.calculateSubtotal(split.items);
  });
},
    
    calculateSubtotal(items) {
      return items.reduce((sum, item) => sum + (item.price * item.quantity), 0).toFixed(2);
    },
    
    async confirmSplit() {
      this.$root.isLoading = true; 
      if (!this.canConfirmSplit) {
        this.$toast.error('Please ensure all quantities are valid');
        return;
      }

      const token = localStorage.getItem('authToken');
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };

      try {
        const payload = {
          equalSplit: this.splitType === 'equal',
          numOrders: this.numSplits,
          splitDetails: []
        };

        if (this.splitType === 'equal') {
          // For equal split, each product is divided equally among all splits
          this.orderItems.forEach(product => {
            for (let i = 0; i < this.numSplits; i++) {
              payload.splitDetails.push({
                subOrderIndex: i + 1,
                productId: product.id,
                quantity: product.quantity / this.numSplits
              });
            }
          });
        } else {
          // For unequal split, use the quantities specified by the user
          this.splitPreview.splits.forEach((split, index) => {
            split.items.forEach(item => {
              if (item.quantity > 0) {
                payload.splitDetails.push({
                  subOrderIndex: index + 1,
                  productId: item.id,
                  quantity: item.quantity
                });
              }
            });
          });
        }

        const response = await fetch(
          `${this.$BASE_API_URL}/api/orders/split/${this.mainOrderId}`,
          {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
          }
        );

        if (response.ok) {
          this.$toast.success('Order split successfully');
          this.$router.push({ name: 'PosComponent' });
        } else {
          throw new Error('Failed to split order');
        }
      } catch (error) {
        console.error('API Error:', error);
        this.$toast.error('An error occurred while splitting the order');
      }
      finally {
        this.$root.isLoading = false;
        this.loading = false;
      }
    }
  },
  async created() {
    this.mainOrderId = this.$route.params.orderId;
    await this.fetchOrderDetails();
  }
}
</script>



<style>
.split-invoice-container {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.split-container {
  display: flex;
  gap: 20px;
}

.split-controls {
  flex: 1;
  max-width: 300px;
}

.split-preview-container {
  flex: 2;
}

.split-options {
  display: flex;
  align-items: center;
}

.split-preview {
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid;
  padding: 10px;
  border-radius: 4px;
}

.split-group {
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  margin-bottom: 15px;
}

.table-cards {
  margin: 5px;
  border-radius: 8px;
  color: white;
  text-align: center;
  cursor: pointer;
}

.form-control {
  display: block;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.badge-success {
  color: #fff;
  background-color: #28a745;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.text-muted {
  color: #6c757d !important;
}
</style>